import { DatePipe } from '@angular/common';
import { Component, computed, EventEmitter, inject, input, LOCALE_ID, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { faArrowTurnDownLeft } from '@fortawesome/pro-regular-svg-icons';
import { I18nModule } from '@pflegix/i18n';
import { GlobalSearchModel, IGlobalSearchModelData } from '@pflegix/types';
import { IconComponent } from '@pflegix/ui';
import { ButtonModule } from 'primeng/button';
import { ContextMenuModule } from 'primeng/contextmenu';
import { filter, map } from 'rxjs';
import { GlobalSearchEventService } from '../../services/global-search-event.service';

@Component({
  selector: 'pfx-global-search-result-item',
  imports: [IconComponent, I18nModule, ContextMenuModule, ButtonModule, RouterLink, DatePipe],
  templateUrl: './global-search-result-item.component.html',
  styleUrl: './global-search-result-item.component.scss',
  providers: [{ provide: LOCALE_ID, useValue: 'de-DE' }],
})
export class GlobalSearchResultItemComponent {
  public item = input.required<IGlobalSearchModelData>();

  public isLoading = input<boolean>(false);

  public isHistoryItem = input<boolean>(false);

  public isSelected = input<boolean>(false);

  @Output() public deleteItem = new EventEmitter<IGlobalSearchModelData>();

  protected searchUrl = '';

  private readonly globalSearchEventService = inject(GlobalSearchEventService);

  protected isItemSelected$ = this.globalSearchEventService.selectedModel$.pipe(
    filter((model) => !!model),
    map((model) => model._id === this.item()._id)
  );

  protected faArrowTurnDownLeft = faArrowTurnDownLeft;

  protected GLOBAL_SEARCH_MODEL_HIDDEN_STATUSES: readonly GlobalSearchModel[] = ['Documentation'] as const;

  protected handleClick(model: IGlobalSearchModelData): void {
    this.globalSearchEventService.selectModel(model);
  }

  protected handleContextMenu(model: IGlobalSearchModelData): void {
    this.searchUrl = this.globalSearchEventService.getUrl(model);
  }

  protected handleDelete(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.deleteItem.emit(this.item());
  }

  protected readonly getIconClass = computed(() => {
    if (this.isHistoryItem()) {
      return 'pi pi-history history-icon';
    }

    const { model } = this.item();

    // todo: use global font awesome mappings
    const iconMapping: Record<GlobalSearchModel, string> = {
      BusinessPartner: 'pi pi-user',
      User: 'pi pi-user-edit',
      Lead: 'pi pi-briefcase',
      Task: 'pi pi-check-square',
      Post: 'pi pi-send',
      Application: 'pi pi-envelope',
      Order: 'pi pi-file',
      Documentation: 'pi pi-book',
    };

    const { [model]: iconClass } = iconMapping;

    return iconClass || 'pi pi-question-circle';
  });
}
